import React from 'react'
import { ColumnRank, ColumnNoc, ColumnName, ColumnBib, ColumnExpander } from "components/common/TableColumns"
import { findArray } from 'helpers/utils'
import Label from "components/general/Label"


export function TableColumns() {

    let columns = [
        ColumnRank({}),
        ColumnBib({ label: 'HeaderBibNoR', headerClassName: 'text-end w-5 align-middle' }),
        ColumnNoc({}),
        ColumnName({}),
        ColumnVictories({}),
        ColumnDefeats({}),
        ColumnPenalties({}),
        ColumnRRPoints({}),
        ColumnVicTied({}),
        ColumnRemarks({}),
        ColumnExpander({})
    ]
    return (
        columns
    )
}

export function TableColumnsSM() {

    let columns = [
        ColumnRank({}),
        ColumnNoc({}),
        ColumnName({}),
        ColumnVictories({}),
        ColumnDefeats({}),
        ColumnPenalties({}),
        ColumnRRPoints({}),
        ColumnVicTied({}),
        ColumnRemarks({headerClassName: 'text-start w-5 align-middle', className: 'text-start'})
    ]
    return (
        columns
    )
}

export function ColumnVictories({
    className = 'text-end',
    headerClassName = 'text-end w-5 text-nowrap align-middle',
    label = 'HeaderVictories',
    remove = false,
}) {
    return (
        {
            Header: <Label data={label} />,
            className: className,
            headerClassName: headerClassName,
            id: 'FenVictories',
            remove: remove,
            accessor: (props) => {
                let value = findArray(props?.extendedResults, { er_type: ['ER_FE'], er_code: ['VIC'] })?.er_value
                return value
            }
        }
    )
}

export function ColumnDefeats({
    className = 'text-end',
    headerClassName = 'text-end w-5 text-nowrap align-middle',
    label = 'HeaderDefeats',
    remove = false,
}) {
    return (
        {
            Header: <Label data={label} />,
            className: className,
            headerClassName: headerClassName,
            id: 'FenDefeats',
            remove: remove,
            accessor: (props) => {
                let value = findArray(props?.extendedResults, { er_type: ['ER_FE'], er_code: ['DEF'] })?.er_value
                return value
            }
        }
    )
}

export function ColumnPenalties({
    className = 'text-end',
    headerClassName = 'text-end w-5 text-nowrap align-middle',
    label = 'HeaderPenalties',
    remove = false,
}) {
    return (
        {
            Header: <Label data={label} />,
            className: className,
            headerClassName: headerClassName,
            id: 'FenPenalties',
            remove: remove,
            accessor: (props) => {
                let value = findArray(props?.extendedResults, { er_type: ['ER_FE'], er_code: ['PTY'] })?.er_value
                return value
            }
        }
    )
}

export function ColumnVicTied({
    className = 'text-end',
    headerClassName = 'text-end w-5 text-nowrap align-middle',
    label = 'LabelVT',
    remove = false,
}) {
    return (
        {
            Header: <Label data={label} />,
            className: className,
            headerClassName: headerClassName,
            id: 'FenVicTied',
            remove: remove,
            accessor: (props) => {
                let value = findArray(props?.extendedResults, { er_type: ['ER_FE'], er_code: ['VIC_TIED'] })?.er_value
                return value
            }
        }
    )
}

export function ColumnRRPoints({
    className = 'text-end fw-bold',
    headerClassName = 'text-end w-5',
    label = 'HeaderMPPoints',
    remove = false,
}) {
    return (
        {
            Header: <Label data={label} />,
            className: className,
            headerClassName: headerClassName,
            id: 'FenRRPoints',
            remove: remove,
            accessor: (props) => {
                let value = props?.resultData
                return value
            }
        }
    )
}

export function ColumnRemarks({
    className = 'text-center fw-bold',
    headerClassName = 'text-end w-5 align-middle',
    label = 'HeaderRemarks',
    remove = false,
}) {
    return (
        {
            Header: <Label data={label} />,
            className: className,
            headerClassName: headerClassName,
            id: 'FenRemarks',
            remove: remove,
            accessor: (props) => {
                let value = props?.resultIrm
                return value
            }
        }
    )
}

export default TableColumns

